import React, { useState } from "react";
import moment from "moment";
import infoIcon from "../../assets/svg/infoIconGrey.svg";
import { BrandName } from "../shared/BrandName";

type CardDetailsProps = {
  validity: string;
  idNumber: string;
  dob: string;
  gender: string;
  idType?: string;
  textColor?: string | null;
};

const formatCardDate = (value: string) => {
  const trimmedValue = value?.trim();

  if (!trimmedValue) {
    return "";
  }

  const parsedDate = moment(
    trimmedValue,
    ["DD-MM-YYYY", "YYYY-MM-DD", moment.ISO_8601],
    true
  );

  return parsedDate.isValid() ? parsedDate.format("DD-MM-YYYY") : trimmedValue;
};

const CardDetails: React.FC<CardDetailsProps> = ({
  validity,
  idNumber,
  dob,
  gender,
  idType,
  textColor = "#1E1E1E",
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const formattedValidity = formatCardDate(validity);
  const formattedDob = formatCardDate(dob);

  return (
    <div className="grid grid-cols-2 w-full">
      {/* VALIDITY */}
      <div className="flex-1">
        <div className="flex items-center gap-1 relative">
          <p className={`text-[${textColor}] text-[10px] font-bold opacity-40`}>
            VALIDITY
          </p>

          <div
            className="relative cursor-pointer"
            onClick={() => setShowTooltip(!showTooltip)}
          >
            {showTooltip && (
              <div className="absolute -translate-x-1/2 bottom-4 whitespace-nowrap bg-black text-white text-[10px] px-2 py-1 rounded shadow-lg z-50">
                ID validity period on <BrandName />
              </div>
            )}
            <img src={infoIcon} alt="info" />
          </div>
        </div>

        <p className={`text-[${textColor}] uppercase text-[9px] font-medium`}>
          {formattedValidity}
        </p>
      </div>

      {/* ID NUMBER or NJOY ID */}
      <div className="flex-1 mb-1">
        <p className={`text-[${textColor}] text-[10px] font-bold opacity-40`}>
          {idType === 'Njoy Youth' ? 'NJOY ID' : 'ID NUMBER'}
        </p>
        <p className={`text-[${textColor}] uppercase text-[9px] font-medium`}>
          {idNumber}
        </p>
      </div>

      {/* GENDER */}
      <div className="flex-1">
        <p className={`text-[${textColor}] text-[10px] font-bold opacity-40`}>
          GENDER
        </p>
        <p className={`text-[${textColor}] uppercase text-[9px] font-medium`}>
          {gender}
        </p>
      </div>

      {/* DOB */}
      <div className="flex-1">
        <p className={`text-[${textColor}] text-[10px] font-bold opacity-40`}>
          DOB
        </p>
        <p className={`text-[${textColor}] uppercase text-[9px] font-medium`}>
          {formattedDob}
        </p>
      </div>

    </div>
  );
};

export default CardDetails;
